import React, { useState } from 'react';
import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import logo from '../../images/logo-image.jpeg';
import { changePassword } from '../../services/AuthService';
import { useAuth } from '../../context/authContext';

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      await Swal.fire({
        icon: 'error',
        title: 'Passwords do not match',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
      return;
    }
    setSubmitting(true);
    try {
      await changePassword({ currentPassword, newPassword });
      await Swal.fire({
        icon: 'success',
        title: 'Password updated',
        text: 'Please login again with your new password.',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
      logout();
      navigate('/external-login', { replace: true });
      window.location.href = '/external-login';
    } catch (error) {
      if (error?.response?.status === 401) {
        logout();
        return;
      }
      await Swal.fire({
        icon: 'error',
        title: 'Change failed',
        text: error?.response?.data?.data || 'Please try again.',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="vh-100" style={{ backgroundColor: '#508bfc' }}>
      <Row className="d-flex justify-content-center align-items-center h-100">
        <Col md={4} lg={4} xl={4}>
          <Card className="shadow-2-strong" style={{ borderRadius: '1rem' }}>
            <Card.Body className="p-3">
              <div className="text-center">
                <Image src={logo} alt="Logo" className="mb-2" width={'40%'} />
                <h4 className="mb-1">Change Password</h4>
              </div>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="form-outline mb-2">
                  <Form.Control
                    type="password"
                    placeholder="Current Password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    className="form-control-lg"
                    required
                  />
                </Form.Group>
                <Form.Group className="form-outline mb-2">
                  <Form.Control
                    type="password"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="form-control-lg"
                    required
                  />
                </Form.Group>
                <Form.Group className="form-outline mb-3">
                  <Form.Control
                    type="password"
                    placeholder="Confirm New Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="form-control-lg"
                    required
                  />
                </Form.Group>
                <div className="d-grid gap-2">
                  <Button type="submit" className="btn btn-primary btn-lg" disabled={submitting}>
                    Update Password
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </section>
  );
};

export default ChangePassword;
